import { render, staticRenderFns } from "./termos_responsabilidade.vue?vue&type=template&id=43bde716&"
import script from "./termos_responsabilidade.vue?vue&type=script&lang=js&"
export * from "./termos_responsabilidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports